import { Navbar, Footer } from "@/components/Layout";
import { useSeo } from "@/hooks/useSeo";

export default function PrivacyPolicy() {
  useSeo({
    title: "Integritetspolicy",
    description: "TimberNets integritetspolicy — hur vi samlar in, använder och skyddar dina personuppgifter i enlighet med GDPR.",
    path: "/integritetspolicy",
  });
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container max-w-3xl flex-1 py-8">
        <h1 className="mb-6 font-display text-2xl font-bold md:text-3xl">Integritetspolicy</h1>
        <div className="prose prose-sm max-w-none text-muted-foreground space-y-4 text-sm leading-relaxed">
          <p>TimberNet värnar om din integritet. Denna policy beskriver hur vi samlar in, använder och skyddar dina personuppgifter i enlighet med GDPR.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Vilka uppgifter samlar vi in?</h2>
          <p>Vi samlar in namn, e-postadress, telefonnummer, adress och betalningsuppgifter i samband med kontoregistrering och bokningar.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Hur använder vi uppgifterna?</h2>
          <p>Uppgifterna används för att hantera bokningar, betalningar, kommunikation och förbättra vår tjänst.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Dina rättigheter</h2>
          <p>Du har rätt att begära tillgång till, rättelse eller radering av dina personuppgifter. Kontakta oss på dataskydd@timbernet.se.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Kontakt</h2>
          <p>Dataskyddsansvarig: dataskydd@timbernet.se</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
